import React from 'react'
import './footer.css'
import {IoIosMail} from 'react-icons/io'
import {FaGithubSquare} from 'react-icons/fa'
import {RiDiscordFill} from 'react-icons/ri'

const Footer = () => {
  return (
    <footer>
      <a href='/#' className='footer__logo'>KH DEV</a>
      <ul className="permalinks">
        <li><a href="/#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#reviews">Testimonials</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className='footer__socials'>
        <a href='mailto:khdevelopment@gmail.com'><IoIosMail/></a>
        <a href='https://github.com/Killerhunter100'><FaGithubSquare/></a>
        <a href='https://discord.gg/gEwsEn7WYy'><RiDiscordFill/></a>
      </div>

      <div className="footer__copyright">
        <small>&copy; KHDEV STORE</small>
      </div>
    </footer>
  )
}

export default Footer